import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Configuration, Constants } from "msal";
import {
  MsalAngularConfiguration,
  MsalModule,
  MsalService,
  MSAL_CONFIG,
  MSAL_CONFIG_ANGULAR,
} from "@azure/msal-angular";
import { environment } from "src/environments/environment";
import { EnvService } from "@services/env.service";
import { TenantInfoService } from "@services/tenant-info.service";

export function MSALConfigFactory(): Configuration {
  const isIE =
    window.navigator.userAgent.indexOf("MSIE ") > -1 ||
    window.navigator.userAgent.indexOf("Trident/") > -1;

  const redirectUri = window.location.origin + window.location.pathname;

  // Seleção de tenant via query param + localStorage
  // ?legacy-login  → ativa diretório legado e persiste escolha
  // ?default-login → remove preferência e usa o padrão (legacy)
  const TENANT_LEGACY  = 'c0945b70-f0ab-4396-baf1-4645f44ee549';
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('legacy-login')) {
    localStorage.setItem('invoicecon_tenant_mode', 'legacy');
  } else if (urlParams.has('default-login')) {
    localStorage.removeItem('invoicecon_tenant_mode');
  }
  const isLegacy = localStorage.getItem('invoicecon_tenant_mode') === 'legacy';
  const cachedTenantInfo = TenantInfoService.getCached();

  const tenantId = isLegacy
    ? TENANT_LEGACY
    : (cachedTenantInfo?.tenantId && cachedTenantInfo.tenantId !== TENANT_LEGACY
        ? cachedTenantInfo.tenantId
        : TENANT_LEGACY);

  // Substituir prefixo do token para hom e sup
  if (['hom', 'sup'].includes(environment.environment.toLowerCase())) {
    Object.defineProperty(Constants, "cachePrefix", {
        get: function () { return `${EnvService.cliente}.msal`; },
        enumerable: false,
        configurable: true
    });
  }

  const isCiam = !isLegacy && !!cachedTenantInfo?.ciamSubdomain;

  const clientId = isCiam
    ? cachedTenantInfo.clientId
    : (cachedTenantInfo?.clientId || environment.azure_enterprise_application);

  const authConfig: any = {
    clientId,
    authority: isCiam
      ? `https://${cachedTenantInfo.ciamSubdomain}.ciamlogin.com/${tenantId}`
      : `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: undefined,
    navigateToLoginRequestUrl: false,
  };

  if (isCiam) {
    authConfig.knownAuthorities = [`${cachedTenantInfo.ciamSubdomain}.ciamlogin.com`];
  }

  return {
    auth: authConfig,
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: isIE || isCiam, // CIAM precisa de cookie para estado cross-domain
    },
  };
}

export function MSALAngularConfigFactory(): MsalAngularConfiguration {
  const cachedTenantInfo = TenantInfoService.getCached();
  const isLegacy = localStorage.getItem('invoicecon_tenant_mode') === 'legacy';
  const isCiam = !isLegacy && !!cachedTenantInfo?.ciamSubdomain;

  const clientId = isCiam
    ? cachedTenantInfo.clientId
    : (cachedTenantInfo?.clientId || environment.azure_enterprise_application);

  const protectedResourceMap: [string, string[]][] = [
    [`${environment.api_endpoint}/api`, [`api://${clientId}/user_impersonation`]],
    ["/assets", [`api://${clientId}/user_impersonation`]],
  ];

  const isIE =
    window.navigator.userAgent.indexOf("MSIE ") > -1 ||
    window.navigator.userAgent.indexOf("Trident/") > -1;

  return {
    popUp: !isIE,
    consentScopes: [
      `api://${clientId}/user_impersonation`,
      'offline_access',
    ],
    protectedResourceMap: protectedResourceMap,
    extraQueryParameters: {},
  };
}

@NgModule({
  imports: [CommonModule, MsalModule],
})
export class MsalApplicationModule {
  static forRoot(): ModuleWithProviders<MsalApplicationModule> {
    return {
        ngModule: MsalApplicationModule,
        providers: [
            {
                provide: MSAL_CONFIG,
                useFactory: MSALConfigFactory,
            },
            {
                provide: MSAL_CONFIG_ANGULAR,
                useFactory: MSALAngularConfigFactory,
            },
            MsalService,
        ],
    };
}
}
